module.exports = __webpack_public_path__ + "bcc6855fcbf5b83dfc6f63d8af467f46.svg";